module.exports = __webpack_public_path__ + "img/bb_g3_t_ears-01.e00bc7a9.svg";